import React from "react";
import {Grid, IconButton} from "@material-ui/core";
import styled from "styled-components";
import {StyledInput} from "../../form/input";
import {StyledSelect} from "../../form/select";
import {ExternalLinkTypeEnum} from "../../../models/external-link-type.enum";
import {FieldArray} from "formik";
import {StyledButton} from "../../ui-base/button";
import {CustomTrashIcon} from "../../ui-base/icons/custom-trash-icon";
import {Colors} from "../../../theme/colors";
import {useTranslation} from "react-i18next";

export const EditProfileSocialMediaLinks: React.FC<{values: any, fieldName: any, handleChange: any, errors?: any, touched?: any}> = ({values, fieldName, handleChange, errors, touched}) => {
    const { t } = useTranslation('author');

    const linkTypes: string[] = Object.values(ExternalLinkTypeEnum);

    return (
        <>
            <StyledTitle>{t('editProfileSocialMediaLinks.socialMedia')}:</StyledTitle>
            <FieldArray name={fieldName}>
                {({ remove, push }) => (
                    <Grid container direction="column" spacing={2}>

                        {values[fieldName]?.length > 0 && values[fieldName].map((value, index) => {
                            return <Grid key={index} container direction="row" item spacing={1}>
                                <Grid item xs={12} sm>
                                    <StyledSelect
                                        id={`${fieldName}.${index}.name`}
                                        label={t('editProfileSocialMediaLinks.type')}
                                        onChange={handleChange}
                                        value={values[fieldName][index].name}
                                        options={linkTypes}
                                        error={errors && errors[fieldName] && errors[fieldName][index]?.name && touched && touched[fieldName] && touched[fieldName][index]?.name}
                                    />
                                </Grid>

                                <Grid item xs={12} sm>
                                    <StyledInput
                                        id={`${fieldName}.${index}.url`}
                                        label={t('editProfileSocialMediaLinks.link')}
                                        onChange={handleChange}
                                        value={values[fieldName][index].url}
                                        placeholder={'http://'}
                                        error={errors && errors[fieldName] && errors[fieldName][index]?.url && touched && touched[fieldName] && touched[fieldName][index]?.url}
                                    />
                                </Grid>

                                <Grid item xs={12} sm>
                                    <StyledInput
                                        id={`${fieldName}.${index}.social_likes`}
                                        label={t('editProfileSocialMediaLinks.socialLikes')}
                                        onChange={handleChange}
                                        value={values[fieldName][index].social_likes}
                                        placeholder={''}
                                        error={errors && errors[fieldName] && errors[fieldName][index]?.social_likes && touched && touched[fieldName] && touched[fieldName][index]?.social_likes}
                                    />
                                </Grid>

                                <Grid item sm={"auto"} md={1} container direction={"row"} alignItems={"center"} justifyContent={"center"} style={{flexGrow: 0}}>
                                    <IconButton aria-label="delete" onClick={() => {
                                        remove(index);
                                    }}>
                                        <CustomTrashIcon style={{fill: 'transparent'}}/>
                                    </IconButton>
                                </Grid>
                            </Grid>
                        })}

                        <Grid item xs={12}>
                            <StyledButton type="button" color={"transparentViolet"} onClick={() => {
                                push({id: null, name: '', url: '', social_likes: 0});
                            }}>
                                {t('editProfileSocialMediaLinks.add')}
                            </StyledButton>
                        </Grid>
                    </Grid>
                )}
            </FieldArray>
        </>
    );
}

const StyledTitle = styled('p')`
  color: ${Colors.lightViolet};
  font-size: 1.1rem;
  font-weight: 500;
`;
